import styled from '@emotion/styled';
import { breakpoints, spacing } from '@naf/theme';

export const ToCWrapper = styled.nav`
  margin-bottom: ${spacing.space32};

  ul {
    padding-left: 0;
    margin: 0;
    li {
      list-style-type: none;
      margin-bottom: ${spacing.space8};

      @media (max-width: ${breakpoints.m}) {
        margin-bottom: ${spacing.space16};
      }

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  @media (max-width: ${breakpoints.m}) {
    margin-bottom: ${spacing.space48};
  }
`;

export const ToCHeading = styled.div`
  display: flex;
  align-items: center;

  h3,
  svg {
    margin-bottom: ${spacing.space8};
    margin-top: 0;
    @media (max-width: ${breakpoints.m}) {
      margin-bottom: ${spacing.space16};
    }
  }

  svg {
    margin-right: ${spacing.space4};
  }
`;
